import { FC } from 'react'
import { DefaultChip } from '@omnea-app/frontend/components/shared/ui/chip/DefaultChip'
import { getRiskScoreColorSx } from '../../../../../../../../color/getRiskScoreColorSx'

type Props = {
  possibleScores: number[]
  score: number
  size?: 'small' | 'medium' | 'tiny'
}

export const RiskMatrixScoreScaleChip: FC<Props> = ({ possibleScores, score, size }) => (
  <DefaultChip
    label=""
    color="neutral"
    size={size}
    sx={{
      width: size === 'tiny' ? '4px' : '6px',
      ...getRiskScoreColorSx({
        possibleScores,
        score,
        type: 'dark',
      }),
    }}
  />
)
